/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Rental_Nights_CountInputs */

const en_rental_nights_count = /** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} night${i?.plural}`)
};

const es_rental_nights_count = /** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} noche${i?.plural}`)
};

const fr_rental_nights_count = /** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nuit${i?.plural}`)
};

const de_rental_nights_count = /** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Nacht${i?.plural}`)
};

const id_rental_nights_count = /** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} malam`)
};

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const ja_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const zh_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const ar_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const it_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const ru_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const pt_rental_nights_count = en_rental_nights_count;

/** @type {(inputs: Rental_Nights_CountInputs) => LocalizedString} */
const ko_rental_nights_count = en_rental_nights_count;

/**
* | output |
* | --- |
* | "{count} night{plural}" |
*
* @param {Rental_Nights_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_nights_count = /** @type {((inputs: Rental_Nights_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Nights_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_nights_count(inputs)
	if (locale === "es") return es_rental_nights_count(inputs)
	if (locale === "fr") return fr_rental_nights_count(inputs)
	if (locale === "de") return de_rental_nights_count(inputs)
	if (locale === "ja") return ja_rental_nights_count(inputs)
	if (locale === "zh") return zh_rental_nights_count(inputs)
	if (locale === "ar") return ar_rental_nights_count(inputs)
	if (locale === "id") return id_rental_nights_count(inputs)
	if (locale === "it") return it_rental_nights_count(inputs)
	if (locale === "ru") return ru_rental_nights_count(inputs)
	if (locale === "pt") return pt_rental_nights_count(inputs)
	return ko_rental_nights_count(inputs)
});